import React, { useState } from "react";
import "../styles/Hotelhelppanel.css";
import { useGame } from "../GameContext";
interface HelpPanelProps {
  GameStyle: "orbital" | "adress";
}
const Helppanel: React.FC<HelpPanelProps> = ({ GameStyle }) => {
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="hotel-helpPanel" id="hotel-helpPanel">
      <img
        src="/img/close.svg"
        id="hotel-closeButton"
        alt="Закрыть"
        className="hotel-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="hotel-helpPivots">
        <div
          className="hotel-selectPivots"
          id={showhelpPivots === "pivotTask" ? "hotel-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
    
        <div
          className="hotel-selectPivots"
          id={showhelpPivots === "pivotCommands" ? "hotel-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotCommands")}
        >
          Команды
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="hotel-commandsCards">
          <div className="hotel-helpCard">
            <div className="hotel-cardCaption">Суть игры</div>
            <div>
              <div>
                {GameStyle === "orbital"
                  ? "Запиши в ячейках адресной книги координаты комнат, где живут гости Волшебного леса."
                  : "Найди комнату отеля по адресу, который указан в адресной книге."}
              </div>
            </div>
          </div>
          <div className="hotel-helpCard">
            <div className="hotel-cardCaption">Правила игры</div>
            <div>
              <div>
                {GameStyle === "orbital" ? (
                  <>
                    В окнах дома появляются персонажи. Рядом с каждым фото есть
                    поле для ввода адреса. Введи координаты окна с этим
                    персонажем (например, а2) и нажми «Проверить». <br />
                    <br />
                    Если адрес верный, звонок загорится зелёным, а окно
                    подсветится. Если нет – звонок красный.
                    <br />
                    <br />
                    *Заполни адресную книгу полностью
                  </>
                ) : (
                  <>
                    В адресной книге написан адрес комнаты. Нажми по нужному
                    окну на игровом поле. <br />
                    <br />
                    Если выбрал правильно – в окне появится гость, а звонок
                    станет зелёным. Если ошибся – звонок красный, и нужно
                    попробовать снова.
                    <br />
                    <br />
                    *Найди всех гостей по их адресам
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
  
      {showhelpPivots === "pivotCommands" && (
        <div id="hotel-commandsCards">
          <div className="hotel-helpCard">
            <div className="hotel-cardCaption">Адреса комнат</div>
            <div>
              <div className="hotel-code">
                <>
                  {" "}
                  <b>xy</b> <br />
                  Буква подъезда <b>x</b>, номер этажа <b>y</b>
                </>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
